import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/archive-restore.vue
var o = {
	name: "DtIconArchiveRestore",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--archive-restore"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Archive Restore",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M2 2.5a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 2 4h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H2ZM.5 3A1.5 1.5 0 0 1 2 1.5h8A1.5 1.5 0 0 1 11.5 3v.5a1.5 1.5 0 0 1-1 1.415V9A1.5 1.5 0 0 1 9 10.5H8a.5.5 0 0 1 0-1h1a.5.5 0 0 0 .5-.5V5h-7v4a.5.5 0 0 0 .5.5h1a.5.5 0 0 1 0 1H3A1.5 1.5 0 0 1 1.5 9V4.915A1.5 1.5 0 0 1 .5 3.5V3Zm5.146 3.146a.5.5 0 0 1 .708 0l1.5 1.5a.5.5 0 1 1-.708.708L6.5 7.707V10a.5.5 0 0 1-1 0V7.707l-.646.647a.5.5 0 1 1-.708-.708l1.5-1.5Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=archive-restore.js.map